import { IResponse, get, post } from "@Lib/request";
import { path } from "./url";
import { IMoviesShortsList } from "@Types/movies";
const { newCarApiV1, newCarApiV2, newCarApiV3, newCarApiV4, newCarApiV5 } = path;

/** 热门厂牌 */
export async function fetchGetEvBrands(params) {
  return await get(`${newCarApiV5}/kinds/hot-brands`, params);
}

/** 新车上市 */
export async function fetchNewlyListedCar(params) {
  return await get(`${newCarApiV1}/newlyListedCar`, params);
}

/** 最新优惠 / 续航排行 */
export async function fetchNewOffersList(params) {
  return await get(`${newCarApiV5}/ev/kind-polymer/list`, params);
}

/** 补贴政策 */
export async function fetchPolicyList(params) {
  return await get(`${newCarApiV3}/ev/discount`, params);
}

/** 销量排行 */
export async function fetchSalesRankList(params) {
  return await get(`${newCarApiV1}/hotsell`, params);
}